import { createContext } from 'react';

export const settledBottomNavItemContext = createContext<string | null>(null);
